export default __webpack_public_path__ + "static/media/author-1.157a449e.png";